/**
 * DevExtreme (esm/ui/html_editor.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import HtmlEditor from "./html_editor/ui.html_editor";
export default HtmlEditor;
